<script lang="ts" setup>
defineProps({
  tip: {
    type: String,
    default: '',
  },
});
</script>

<template>
  <h2 class="flex h-[18px] items-center justify-start">
    <slot></slot>
    <slot name="tip">
      <template v-if="tip">
        <a-divider type="vertical" class="!mx-3"></a-divider>
        <span class="text-sm text-colorTextSecondary">{{ tip }}</span>
      </template>
    </slot>
  </h2>
</template>
